import axios from "axios";
import { headers } from "./TokenHeader";
import { Urls } from "./ApiPath";
import { Auth } from "../auth/Auth";

const getProductsByStore = (store) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Urls.products.v3.byStore}?store=${store}`, { headers: headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const ProductsByStoreService = {
  getProductsByStore,
};
